<template>
    <div>
        <img v-if="channelName == 'Max (includes HBO ch.)'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/hbomax.webp" alt="Max (includes HBO ch.)"/>
        <img v-if="channelName == 'Showtime'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/showtime-red.webp" alt="Showtime"/>
        <img v-if="channelName == 'Cinemax'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/cinemax-black.webp" alt="Cinemax"/>
        <img v-if="channelName == 'Starz and StarzEncore'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/starz-icon.webp" alt="Starz and StarzEncore"/>
        <img v-if="channelName == 'MGM+'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/mgm_plus.webp" alt="MGM+"/>
        <img v-if="channelName == 'MoviePlex'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/movieplex-icon.webp" alt="MoviePlex"/>
        <img v-if="channelName == 'Playboy'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/Playboy-icon.webp" alt="Playboy"/>
        <img v-if="channelName == 'Playboy Espanol'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/Playboy-TV-esp-icon.webp" alt="Playboy Espanol">
        <h3 v-if="channelName == 'Latinx+'" class="text-2xl mx-auto mb-8 flex justify-center">
            Latinx+
        </h3>
        <h3 v-if="channelName == 'TV5 Monde'" class="text-2xl mx-auto mb-8 flex justify-center">
            TV5 Monde
        </h3>
        <img v-if="channelName == 'Rai Italia'" class="mx-auto mb-8" style="max-width: 120px; max-height: 42px;" src="/assets/network-icons/Rai_Italia-icon.webp" alt="Rai Italia"/>
        <h3 v-if="channelName == 'DW Amerika'" class="text-2xl mx-auto mb-8 flex justify-center">
            DW Amerika
        </h3>

    </div>
</template>

<script>
export default {
    name: 'AdditionalChannelsImage',
    props: {
        channelName: {
            type: String,
            required: true,
        },
    },
}
</script>
